import type { Me } from "../api";
import type { SessionAction, SessionState } from "./types";

/** L'état de départ : on ne sait encore rien. */
export const SESSION_INITIAL: SessionState = { status: "loading" };

/**
 * Réduction de l'état de session. Pure, donc testable sans React.
 *
 * `companyUpdated` hors d'un état authentifié est ignoré : une réponse de
 * mise à jour de marque arrivée après une déconnexion ne ressuscite personne.
 */
export function sessionReducer(state: SessionState, action: SessionAction): SessionState {
  switch (action.type) {
    case "resolved":
      return authenticated(action.me);
    case "unavailable":
      return { status: "unavailable", error: action.error };
    case "unauthenticated":
      return { status: "anonymous" };
    case "companyUpdated":
      if (state.status !== "authenticated") {
        return state;
      }
      return { ...state, company: action.company };
    default:
      return state;
  }
}

function authenticated(me: Me): SessionState {
  return {
    status: "authenticated",
    user: me.user,
    company: me.company,
    permissions: me.permissions,
  };
}
